import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xxl-8" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap mb-3" }
const _hoisted_4 = { class: "me-7 mb-4" }
const _hoisted_5 = { class: "symbol symbol-100px symbol-lg-160px symbol-fixed position-relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 1,
  src: "/media/avatars/blank.png",
  alt: ""
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "position-absolute translate-middle bottom-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-20px w-20px" }, null, -1)
const _hoisted_9 = { class: "flex-grow-1" }
const _hoisted_10 = { class: "d-flex justify-content-between align-items-start flex-wrap mb-2" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex align-items-center mb-2" }
const _hoisted_13 = {
  href: "#",
  class: "text-gray-800 text-hover-primary fs-2 fw-bolder me-1"
}
const _hoisted_14 = { href: "#" }
const _hoisted_15 = { class: "svg-icon svg-icon-1 svg-icon-primary" }
const _hoisted_16 = { class: "d-flex flex-wrap fw-bold fs-6 mb-4 pe-2" }
const _hoisted_17 = {
  href: "#",
  class: "d-flex align-items-center text-gray-400 text-hover-primary mb-2"
}
const _hoisted_18 = { class: "svg-icon svg-icon-4 me-1" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex my-4" }, null, -1)
const _hoisted_20 = { class: "d-flex flex-wrap flex-stack" }
const _hoisted_21 = { class: "d-flex flex-column flex-grow-1 pe-8" }
const _hoisted_22 = { class: "d-flex flex-wrap" }
const _hoisted_23 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_24 = { class: "d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-success me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-phone-alt" })
], -1)
const _hoisted_26 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "4500",
  "data-kt-countup-prefix": "$"
}
const _hoisted_27 = { class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3" }
const _hoisted_28 = { class: "d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-calendar-minus" })
], -1)
const _hoisted_30 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_31 = {
  key: 0,
  class: "border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3"
}
const _hoisted_32 = { class: "" }
const _hoisted_33 = { class: "d-flex align-items-center" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3 svg-icon-danger me-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-money-bill-wave" })
], -1)
const _hoisted_35 = {
  class: "fs-2 fw-bolder",
  "data-kt-countup": "true",
  "data-kt-countup-value": "75"
}
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center w-200px w-sm-300px flex-column mt-3" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              (_ctx.user.avatar)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "avatar-photo",
                    src: _ctx.site_url +'/'+ _ctx.user.avatar,
                    alt: ""
                  }, null, 8, _hoisted_6))
                : (_openBlock(), _createElementBlock("img", _hoisted_7)),
              _hoisted_8
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.user.first_name + ' ' + _ctx.user.last_name), 1),
                  _createElementVNode("a", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen026.svg" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("a", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com011.svg" })
                    ]),
                    _createTextVNode(" " + _toDisplayString(_ctx.user.email), 1)
                  ])
                ])
              ]),
              _hoisted_19
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.user.phone), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.user.date_of_birth), 1)
                    ])
                  ]),
                  (_ctx.hasBonus(_ctx.user.bonus))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                        _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.$t('bonus_is_availiable_for')), 1),
                        _createElementVNode("div", _hoisted_33, [
                          _hoisted_34,
                          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.user.bonus), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _hoisted_36
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view)
  ], 64))
}